import { render, staticRenderFns, recyclableRender, components } from "./fansItme.vue?vue&type=template&id=424a4bfc&scoped=true&"
var renderjs
import script from "./fansItme.vue?vue&type=script&lang=js&"
export * from "./fansItme.vue?vue&type=script&lang=js&"
import style0 from "./fansItme.vue?vue&type=style&index=0&id=424a4bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a4bfc",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/fansManger/fansItme.vue"
export default component.exports